// Owner Scorecard access: ONE cached /analytics/owner-scorecard/ request per tenant,
// shared by the Analytics sub-nav tab and the landing card. The backend is the gate
// (preferences.owner_scorecard.enabled, or t7 in code): {enabled:false} → no tab, no
// card. Keyed by tenant so switching tenant never carries one business's answer
// into another.
import { getOwnerScorecard } from "../../../api/analyticsApi";

const cache = new Map();

export const fetchScorecard = (tenantId) => {
  if (!cache.has(tenantId)) {
    cache.set(tenantId, getOwnerScorecard()
      .then((res) => res?.data || { enabled: false })
      .catch(() => { cache.delete(tenantId); return { enabled: false }; }));
  }
  return cache.get(tenantId);
};

export { SCORECARD_TAB, withScorecardTab } from "./scorecardTabs";
